import React, { useEffect, useState } from "react";
import { Typography, Box, CircularProgress } from "@mui/material";
import getAllEquipment from "./AddEquipment";
import { BarChart } from '@mui/x-charts/BarChart';

const Dashboard = () => {
  const [equipment, setEquipment] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchEquipmentData() {
      try {
        const data = await getAllEquipment(); // Fetch all equipment data
        setEquipment(data);
      } catch (error) {
        console.error("Error fetching equipment data:", error);
      } finally {
        setLoading(false);
      }
    }
    fetchEquipmentData();
  }, []);

  if (loading) {
    return (
      <Box sx={{ textAlign: "center", padding: 3 }}>
        <CircularProgress />
      </Box>
    );
  }

  // Calculate summary data
  const totalEquipment = equipment.length;

  const totalDamaged = equipment.filter((item) => item.Damaged === true || item.Damaged === "true").length;
  const totalCheckedOut = equipment.filter((item) => item.atWarehouse === false || item.atWarehouse === "false").length;

  // Prepare data for the BarChart
  const xAxisData = ['Available', 'Checked-out', 'Damaged'];
  const seriesData = [
    { data: [totalEquipment - totalDamaged - totalCheckedOut, totalCheckedOut, totalDamaged] }
  ];

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" align="center" gutterBottom>
        Equipment Reports Dashboard
      </Typography>


      <BarChart
        xAxis={[{ scaleType: 'band', categoryGapRatio: 0.5, data: xAxisData }]} // Labels for x-axis
        series={[
          {
            data: seriesData[0].data,
            color: ['#2196F3', '#FFEB3B', '#9C27B0'], // Custom colors for each bar (Available, Checked-out, Damaged)
          }
        ]}
        width={400}
        height={300}
      />

      <Box sx={{ textAlign: "center", mt: 2 }}>
        <Typography variant="h6">Available Equipment: {totalEquipment - totalDamaged - totalCheckedOut}</Typography>
        <Typography variant="h6">Total Damaged Equipment: {totalDamaged}</Typography>
        <Typography variant="h6">Total Checked Out Equipment: {totalCheckedOut}</Typography>
      </Box>
    </Box>
  );
};

export default Dashboard;
